import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import Divider from '../../images/Divider.svg'
import Fill from '../../images/Fill.svg'

export const query = graphql`
  query case {
    cone: file(relativePath: {eq: "n2.jpg"}) {
    conechild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    ctwo: file(relativePath: {eq: "osOverlay1.jpg"}) {
    ctwochild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  },
    cthree: file(relativePath: {eq: "Spa.jpg"}) {
    cthreechild: childImageSharp {
      sizes(quality: 100, maxWidth:500, toFormat: PNG, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}) {tracedSVG aspectRatio src}
    }
  }
}
`

const CaseStudies = ({data:{cone, ctwo, cthree}}) => (
  <section>
    <article>
      <div className='container'>
        <div>
          <div style={{display:'block'}}>
            <h1 className='smallerHone'>Case Study</h1>
            <img src={Divider} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
            <p className='smallerHone'><span className='gradient'>Case studies such as these inspire and motivate us.</span></p>
            <p>See how businesses similar to yours are growing with Digital Marketing.</p>
            <p style={{marginBottom:'0'}}>We have been in existence in the digital market field for 2 and half years.
            Knowing that the digital market and business is growing exponentially, Nisadhya has become a leader in digital marketing where we
            have worked with more than 15 clients fostering their growth and successfully solving their problems.</p>
          </div>
        </div>
      </div>
      <div className='container' style={{paddingTop:'0'}}>
        <div className='full-Width' style={{alignItems:'flex-start', justifyContent:'space-between'}}>
          <div className='half-Width-30 mobBottommargin'>
            <div className='case-studies'>
              <div style={{overflow:'hidden'}}>
                <Link to='/case-studies/kcl-astute/'><Img className='case-studies-img' sizes={cone.conechild.sizes} alt=" KCL Astute Capital Limited"/></Link>
              </div>
              <div style={{padding:'1.0875rem'}}>
                <h1 className='smallerHone'><span className='gradient'>KCL Astute.</span></h1>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
                <p>KCL Astute Capital Limited is a Merchant Banker licensed by Securities Board of Nepal (SEBON) to render Portfolio Management Services.</p>
                <Link to='/case-studies/kcl-astute/' className='slide gradient'>View Case Study</Link>
              </div>
            </div>
          </div>
          <div className='half-Width-30'>
            <div className='case-studies'>
              <div style={{overflow:'hidden'}}>
                <Link to='/case-studies/wanderthirst-hostels/'><Img className='case-studies-img' sizes={cthree.cthreechild.sizes} alt="WanderThirst Hostels"/></Link>
              </div>
              <div style={{padding:'1.0875rem'}}>
                <h1 className='smallerHone'><span className='gradient'>WanderThirst Hostels.</span></h1>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
                <p>WanderThirst Hostels cater towards backpackers and travellers from all around the world who seek accommodation for an affordable budget.</p>
                <Link to='/case-studies/wanderthirst-hostels/' className='slide gradient'>View Case Study</Link>
              </div>
            </div>
          </div>
          <div className='half-Width-30'>
          </div>
        </div>
      </div>
    </article>
  </section>
)

export default CaseStudies



// WEBPACK FOOTER //
// ./src/pages/case-studies/index.js